<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="setPageNumberAndGetAllQuestions"
  >
    <template #title> لیست سوالات </template>
    <template #titleBtn>
      <BButton variant="success" to="/questions/create"> ساخت سوال </BButton>
    </template>
    <template #filters>
      <SearchInput
        inputLabel="جستجوی متن سوال"
        inputPlaceholder="جستجو..."
        v-model="questionListFilters.searchCommand"
        @enter="setPageNumberAndGetAllQuestions"
      ></SearchInput>
      <QuestionLevelPicker
        class="w-24 filters-width"
        :defaultSelectedLevel="questionListFilters.level"
        v-model="questionListFilters.level"
      >
      </QuestionLevelPicker>
    </template>
    <CustomTable
      :pageNumber="questionListFilters.pageNumber"
      :count="questionListFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="questionsList"
      @changePage="changePage"
    >
      <template #isDescriptive="data"> چهار گزینه‌ای </template>
      <template #createDate="data">
        {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
      </template>
      <template #Edit="data">
        <b-link :to="`/questions/${data.item.questionId}`">
          <feather-icon class="text-primary" icon="EditIcon" size="20" />
        </b-link>
      </template>
      <template #Delete="data">
        <div
          style="cursor: pointer"
          @click="renderDeleteConfirmation(data.item)"
        >
          <feather-icon class="text-danger" icon="Trash2Icon" size="20" />
        </div>
      </template>
      <template #questionLevel="data">
        {{ questionsLevelsTranslate[data.item.questionLevel] }}
      </template>
    </CustomTable>
    <DeleteQuestionConfirmationDialog
      :questionDetails="tempSelectedQuestion"
      @refetch="getAllQuestions"
    ></DeleteQuestionConfirmationDialog>
  </PageWrapper>
</template>
<script>
export default {
  mounted() {
    this.getAllQuestions();
  },
  data() {
    return {
      isLoading: false,
      totalCount: null,
      questionsList: null,
      questionListFilters: {
        pageNumber: 1,
        count: 10,
        searchCommand: null,
        level: null,
        isDescriptive: null,
      },
      totalCount: null,
      questionsLevelsTranslate: {
        1: "آسان",
        2: "معمولی",
        3: "سخت",
        4: "خیلی سخت",
      },
      tableColumns: [
        {
          key: "questionId",
          label: "شناسه سوال",
        },
        {
          key: "questionText",
          label: "متن سوال",
        },
        {
          key: "questionLevel",
          label: "سطح سوال",
        },
        {
          key: "isDescriptive",
          label: "نوع سوال",
        },
        {
          key: "createDate",
          label: "تاریخ ثبت",
        },
        {
          key: "Edit",
          label: "ویرایش",
        },
        {
          key: "Delete",
          label: "حذف",
        },
      ],
      tempSelectedQuestion: null,
    };
  },
  methods: {
    renderDeleteConfirmation(question) {
      this.tempSelectedQuestion = question;
      this.$bvModal.show("delete-question-confirmation-dialog");
    },
    setPageNumberAndGetAllQuestions() {
      this.questionListFilters.pageNumber = 1;
      this.getAllQuestions();
    },
    changePage(pageNumber) {
      this.questionListFilters.pageNumber = pageNumber;
      this.getAllQuestions();
    },

    async getAllQuestions() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllQuestions = new GetAllQuestions(_this);
        getAllQuestions.setRequestParam(_this.questionListFilters);
        await getAllQuestions.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.questionsList = response.data.questions;
              _this.totalCount = response.data.questionsCount;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    SearchInput,
    QuestionLevelPicker,
    CustomTable,
    DeleteQuestionConfirmationDialog,
    BButton,
    BLink,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import QuestionLevelPicker from "@/views/components/Questions/QuestionLevelPicker.vue";
import DeleteQuestionConfirmationDialog from "@/views/components/Questions/DeleteQuestionConfirmationDialog.vue";
import { GetAllQuestions } from "@/libs/Api/Question";
import { BButton, BLink } from "bootstrap-vue";
</script>
